module.exports = __webpack_public_path__ + "static/media/bitty_beaus.7ddbbaf8.jpg";